<template>
  <div class="sidebar-wrapper w100p df fdc" v-bind:class="{
    'show-sidebar': sidebarShown
  }" v-click-outside="closeSidebarIfNeeded">

    <div class="inside-wrap df fdc aic jcfs f1 w100p">

      <!-- Sidebar Top -->
      <!-- <a class="sidebar-top df">
        <img src="../../static/images/cup-wise-logo.svg">
        <p class="f1 cupwise" @click="goTo('/me')"><span>Cup</span>Wise</p>
      </a> -->

      <!-- Sidebar Middle -->
      <div class="sidebar-middle f1 w100p">

<!--         <div class="sidebar-title-wrapper w100p">
          <h3>
            {{$store.getters['AUTH.myPublicData'].displayName || 'New User'}}
          </h3>
          <p>
            What Am I Selling?
          </p>
        </div> -->

        <br/>

        <div class="sidebar-link special-link" v-bind:class="{
          'sidebar-link-current': $route.path == '/cupping'
        }"  @click="goTo('/cupping')">
          <!-- <i class="icon far fa-calendar-star"></i> -->
          <div class="icon icon-coffees"></div>
          <h4>Start Cupping</h4>
        </div>

        <br/>
        <br/>

        <div class="sidebar-link" v-bind:class="{
          'sidebar-link-current': $route.path == '/me'
        }"  @click="goTo('/me')">
          <!-- <p class="icon"></p> -->
          <!-- <i class="icon far fa-home"></i> -->
          <div class="icon icon-home"></div>
          <h4>Home</h4>
        </div>
        <!-- <br/> -->
        <!-- <hr class="hr"/> -->
 <!--        <div v-if="$store.getters['AUTH.myPrivateData'].type == 'alpha'" class="sidebar-title-wrapper w100p">
          <h3>
            Tools
          </h3>
          <p>
            Cupping
          </p>
        </div> -->


        <div class="sidebar-link" v-bind:class="{
          'sidebar-link-current': $route.path == '/sessions'
        }"  @click="goTo('/sessions')">
          <!-- <i class="icon far fa-calendar-star"></i> -->
          <div class="icon icon-sessions"></div>
          <h4>Sessions</h4>
        </div>
<!--         <div class="sidebar-link o05" @click="goTo('/products')">
          <i class="icon-barcode icon"></i>
          <h4>Scored Products</h4>
        </div> -->
        <!-- <hr class="hr"/> -->
        <div class="sidebar-link" v-bind:class="{
          'sidebar-link-current': $route.path == '/templates'
        }" @click="goTo('/templates')">
          <!-- <i class="icon far fa-tasks"></i> -->
          <div class="icon icon-templates"></div>
          <h4>Templates</h4>
        </div>
        
        <!-- <div v-if="($store.getters['AUTH.myPrivateData'].type == 'alpha') || ($store.getters['AUTH.myPrivateData'].type == 'pro')" class="sidebar-link" v-bind:class="{ -->

        <div class="sidebar-link" v-bind:class="{
          'sidebar-link-current': $route.path == '/coffees'
        }"  @click="goTo('/coffees')">
          <!-- <i class="icon far fa-coffee-pot"></i> -->
          <div class="icon icon-coffees"></div>
          <h4>Coffees</h4>
        </div>

        <!-- <div class="sidebar-link sidebar-link-disable posrel" v-bind:class="{
          'sidebar-link-current': $route.path == '/analyze'
        }">
          <div class="icon icon-analyze"></div>
          <h4>Analyze</h4>
          <p class="coming-soon">Coming June 2022</p>
        </div> -->
        <!-- }"  @click="goTo('/analyze')"> -->
          <!-- <i class="icon far fa-calendar-star"></i> -->

        <!-- <br/> -->
        <!-- <br/> -->



  <!--       <div class="sidebar-link sidebar-link-expandable"
              v-bind:class="{
                'sidebar-link-active': showFulfilment
              }"
              @click="goTo('/fulfillment')">
          <p class="icon">I</p>
          <h4 class="f1">Fulfillment</h4>
          <p>></p>
        </div> -->
  <!--       <div class="fulfilment-items df fdc" v-if="showFulfilment">
          <div class="sidebar-link">
            <p class="icon">-</p>
            <h4>My Services</h4>
          </div>
          <div class="sidebar-link">
            <p class="icon">-</p>
            <h4>My Appointments</h4>
          </div>
        </div> -->
  <!--       <div class="sidebar-link" @click="goTo('/appointments')">
          <p class="icon">I</p>
          <h4>Appointments</h4>
        </div> -->
<!--         <div class="my-products df fdc w100p">
          <div class="my-product posrel"
                @click="goToProduct(product)"
                v-for="(product, i) in $store.getters['AUTH.myProductsList']">
            <p class="curp one-product">
              <i v-if="product.type == 'digital-service'" class="icon-bell icon icon-product"></i>
              <i v-else-if="product.type == 'digital-download'" class="icon-download icon icon-product"></i>
              <i v-else-if="product.type == 'calendar-event'" class="icon-calendar icon icon-product"></i>
              <span>
                {{product.name}}
              </span>
            </p>
          </div>
        </div> -->
        <!-- <div class="sidebar-link posrel" @click="toggleAddProductsPopup($event)">
          <i class="icon-plus icon"></i>
          <h4>New</h4>
          <div class="add-popup" v-if="showAddProductPopup" v-click-outside="closeAddProductsPopup">
            <div class="df fdc">
              <a @click="newProduct('digital-download')">Live video session</a>
              <a @click="newProduct('digital-service')">Scored Product</a>
              <a @click="newProduct('calendar-event')">Template</a>
            </div>
          </div>
        </div> -->
      </div>

      <hr class="hr"/>
      <!-- Sidebar Bottom -->
      <div class="sidebar-bottom w100p">
        <!-- <div class="sidebar-link" @click="goTo('/settings')">
          <i class="icon far fa-cogs"></i>
          <h4>Settings</h4>
        </div> -->
        <div class="sidebar-link collapse-link"  @click="closeSidebar()">
          <!-- <i class="icon far fa-arrow-to-left"></i> -->
          <div class="icon icon-collapse"></div>
          <h4>Collapse</h4>
        </div>
       <!--  <div class="sidebar-link" @click="logout()">
          <i class="icon far fa-user"></i>
          <h4>Logout</h4>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>

import router from '../router'
import LandingProduct from '@/components/LandingProduct'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Sidebar',
  data () {
    return {
      loading: false,
      // sidebarShown: true,
      // showFulfilment: true,
      showAddProductPopup: false,
      mediaQueryWidth: 980
    }
  },
  props: ['setSidebarShown', 'sidebarShown'],
  components: {
    LandingProduct
  },
  methods: {
    goToProduct (product) {
      let path = '/add/' + product.type + '/' + product.internalId
      router.push(path)
    },
    logout () {
      this.$store.dispatch('AUTH.logout', {})
    },
    goTo (route) {
      this.closeSidebarIfNeeded()
      router.push(route)
    },
    showSidebar () {
      // this.sidebarShown = true
      this.setSidebarShown(true)
    },
    closeSidebarIfNeeded () {
      console.log('click outside')
      let width = window.innerWidth
      if (width < this.mediaQueryWidth) {
        this.closeSidebar()
      }
    },
    closeSidebar () {
      // this.sidebarShown = false
      this.setSidebarShown(false)
    },
    closeAddProductsPopup () {
      if (this.showAddProductPopup) {
        this.showAddProductPopup = false
      }
    },
    closeFulfilment () {
      if (this.showFulfilment) {
        this.showFulfilment = false
      }
    },
    expandFulfilment (e) {
      e.stopPropagation()
      this.showFulfilment = !this.showFulfilment
    },
    toggleAddProductsPopup (e) {
      e.stopPropagation()
      this.showAddProductPopup = !this.showAddProductPopup
    },
    newProduct (product) {
      this.goTo('/add/' + product)
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Sidebar created', this.$route.path)
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  h3 {
    font-size: 14px;
    color: $color-primary;
    letter-spacing: 0.40px;
    font-weight: 700;
    font-family: Inter;
    
    & + p {
      margin-top: 5px;
      color: #323232;
      font-size: 11px;
      margin-bottom: 0;
      text-transform: capitalize;
      line-height: 1;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  $sidebar-width: 250px;

  .sidebar-wrapper {
    background-color: $color-white;
    left: calc(-1 * #{$sidebar-width});
    top: 0;
    height: 100vh;
    /*width: $sidebar-width;*/
    max-width: $sidebar-width;
    min-width: $sidebar-width;
    z-index: 100;
    transition: all 0.5s ease;
    -webkit-box-shadow: 0 0 21px 0 rgba(89, 102, 122, .1);
    box-shadow: 0 0 21px 0 rgba(89, 102, 122, .1);
    transform: translateX(-100%);
    margin-right: calc(-1 * #{$sidebar-width});
    height: 100%;
  }
  $slideout-width: 40px;
  .slide-out-temp {
    width: $slideout-width;
    text-align: center;
  }
  .sidebar-slideout {
    position: absolute;
    top: 15px;
    background-color: $color-white;
    height: 40px;
    width: $slideout-width;
    /*border-top-right-radius: 10px;*/
    /*border-bottom-right-radius: 10px;*/
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: calc(#{$sidebar-width} - #{$slideout-width} + 15px);
    opacity: 1;
    pointer-events: all;
    cursor: pointer;
    transition: all 0.5s ease;
    z-index: 5;
    transform: translateX(100%);
  }
  .show-sidebar {
    left: 0;
    /*overflow-y: auto;*/
    transform: translateX(0);
    margin-right: 0;
    .sidebar-slideout {
      left: calc(#{$sidebar-width} - #{$slideout-width} - #{$slideout-width} - #{$slideout-width} - #{$slideout-width} - 15px);
      /*opacity: 0;*/
      pointer-events: none;
    }
    .inside-wrap {
      overflow-y: auto;
    }
  }
  @media (max-width: 980px) {
    .sidebar-wrapper {
      position: fixed;
      transform: translateX(0);
      margin-right: 0;
    }
    .sidebar-slideout {
      left: 100%;
      left: calc(#{$sidebar-width} - #{$slideout-width} + 15px);
    }
    .show-sidebar {
      transform: translateX(0);
      margin-right: 0;
      .sidebar-slideout {
        left: calc(#{$sidebar-width} - #{$slideout-width} - #{$slideout-width} - 15px);
        /*opacity: 0;*/
        pointer-events: none;
      }
    }
  }
  .sidebar-top {
    /*height: $header-height;*/
    background-color: $color-white;
    width: 100%;
    padding: 0 20px;
    z-index: 10;
    height: 40px;

    -webkit-box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);
    box-shadow: -9px 0 20px rgba(89, 102, 122, 0.1);
  }

  .sidebar-middle {
    /*height: 100vh;*/
    /*top: 0;*/
    /*position: fixed;*/
    background-color: $color-white;
    padding-left: 16px;
    padding-right: 10px;
    padding-top: 15px;
    /*margin-top: 5px;*/
    margin-bottom: 30px;
  }

  .sidebar-bottom {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 15px;
    .sidebar-link {
      h4 {
        // color: #333;
      }
    }
  }

  .sidebar-splash {
    width: 100%;
    max-width: 720px;
  }

  .sidebar-title-wrapper {
    /*background-color: rgba(115,102,255,0.06);*/
    /*padding: 10px 17px;*/
    border-radius: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*margin-bottom: 10px;*/
    margin-top: 20px;

    margin-bottom: 0;
    padding: 10px;
    background-color: transparent;
  }

  .sidebar-link {
    padding: 16px 10px;
    border-radius: 5px;
    color: #222222;
    display: flex;
    align-items: center;
    transition: all 0.5s ease;
    cursor: pointer;

    &-current {
      h4, .icon {
        color: $color-primary !important;
      }
    }

    &:hover {
      // background-color: rgba(115,102,255,0.12);
      background-color: #27C8B31E;
      
      // rgba(115, 102, 255, 0.12)
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;

      h4, .icon {
        color: $color-primary;
      }
    }

    .icon {
      margin-right: 10px;
      width: 46px;
      height: 26px;
      // font-size: 26px;

      // display: flex;
      // align-items: center;
      // justify-content: center;
    }

    h4 {
      color: #5C5C5C;
      font-family: Inter;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 17px;
    }
  }

  .sidebar-link-expandable {
    &:hover {
      background-color: unset;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;

      h4, .icon {
        color: $color-primary;
      }
    }
  }

  .header-logo {
    margin-right: 8px;
  }

  .add-popup {
    position: absolute;
    left: 80px;
    top: 50%;
    border: 1px solid #ddd;
    width: $sidebar-width;
    background-color: $color-white;
    padding: 20px;
    border-radius: 10px;

    & > div {
      a {
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .sidebar-link-active {
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
    position: relative;
    margin-bottom: 10px;
    background-color: #dad6ff;

    * {
      color: $color-primary;
    }

    &:hover {
      background-color: #dad6ff;;
    }
  }

  .fulfilment-items {
    padding-left: 15px;

    .sidebar-link {
      &:hover {
        background: transparent;
      }
    }
  }

  .inside-wrap {
    /*position: sticky;*/

    border-radius: 5px;
    height: 100vh;
    top: 0;
    height: 100%;
    min-height: unset;
    max-height: 100vh;
    position: sticky;
  }
  
  .fulfillment-remaining {
    /*padding: 3px;bg*/
    min-width: 20px;
    text-align: center;
    font-weight: 700;
    border-radius: 4px;
    font-size: 12px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5468d4;
    color: white;
    font-family: 'CA SaygonText', sans-serif;
  }
  .one-product {
    margin-bottom: 4px;
    margin-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;

    span {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .icon-product {
    margin-right: 8px;
    margin-left: 24px;
  }
  .my-product {
    margin-bottom: 4px;

    p {
      font-family: 'CA SaygonText', sans-serif;
      font-size: 14px;
      font-weight: 400;
    }
    .icon {
      font-size: 18px;
    }

    &:hover {
      p, .icon {
        color: $color-primary;
      }
    }
  }

  .o05 {
    opacity: 0.3;
    pointer-events: none;
  }
  .cupwise {
    display: flex;
    align-items: center;
    color: #000000;
    font-family: Inter;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 20px;
    margin-left: 4px;

    span {
      font-weight: 800;
    }
  }
  .icon-bars {
    font-size: 28px;
  }
  .hr {
    width: calc(100% - 56px);
    height: 1px;
    max-height: 1px;
    border: none;
    border-bottom: 1px solid #979797;

    // padding-right: 30px;
    // padding-left: 30px;
  }

  .collapse-link {
    h4 {
      color: #5C5C5C;
      font-family: Inter;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 13px;
    }
  }
  .icon {
    background-position: center !important;
    background-repeat: no-repeat !important;
    &:before {
      display: none;
    }
  }
  .icon-home {
    background: url('../../static/images/new-icon-home.svg');
  }
  .icon-sessions {
    background: url('../../static/images/icon-new-sessions.svg');
  }
  .icon-analyze {
    background: url('../../static/images/magnifying-glass-light.svg');
  }
  .icon-templates {
    background: url('../../static/images/new-icon-templates.svg');
  }
  .icon-coffees {
    background: url('../../static/images/new-icon-coffee.svg');
  }
  .icon-collapse {
    background: url('../../static/images/icon-new-collapse.svg');
  }
  .icon-profile {
    background: url('../../static/images/icon-new-profile.svg');
  }
  .icon-logout {
    background: url('../../static/images/icon-new-logout.svg');
  }
  .icon-settings {
    background: url('../../static/images/icon-new-settings.svg');
  }
  .sidebar-link:hover, .sidebar-link-current {
      .icon-home {
        background: url('../../static/images/icon-new-home-active.svg');
      }
      .icon-analyze {
        /*color: $color-primary;*/
        /*background-color: $color-primary;*/
        background: url('../../static/images/magnifying-glass-light-active.svg');
      }
      .icon-sessions {
        background: url('../../static/images/icon-new-sessions-active.svg');
      }
      .icon-templates {
        background: url('../../static/images/new-icon-templates-active.svg');
      }
      .icon-coffees {
        background: url('../../static/images/icon-new-coffees-active.svg');
      }
      .icon-collapse {
        background: url('../../static/images/icon-new-collapse-active.svg');
      }
      .icon-profile {
        background: url('../../static/images/icon-new-profile-active.svg');
      }
      .icon-logout {
        background: url('../../static/images/icon-new-logout-active.svg');
      }
      .icon-settings {
        background: url('../../static/images/icon-new-settings-active.svg');
      }
  }

  .sidebar-link-disable {
    pointer-events: none;
    opacity: 0.5;
  }

  .coming-soon {
    position: absolute;
    font-size: 12px;
    bottom: 4px;
    left: 50%;
    opacity: 0.5;
    transform: translateX(-50%);
  }

  .special-link {
    border: 1px solid $color-primary;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Sidebar.vue